<template>
  <div class="box">
    <div class="add" @click="toAddressAdd">
      <img src="../../../../assets/images/icon-address-add@2x.png" alt="" />
      <h1>添加地址</h1>
    </div>
    <div>
      <div class="address_list">
        <div v-for="(item, index) in addressList" :key="index">
          <div class="address_info" @click="addressEdit(item.id)">
            <div class="header2">
              <h1>{{ item.name }}</h1>
              <h1 style="margin-left: 7px">{{ item.phone }}</h1>
              <div v-if="item.is_default == 1" class="first">默认</div>
            </div>
            <div class="body">{{ item.address }}</div>
          </div>
          <div class="line"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AddressAdd",
  data() {
    return {
      addressList: [],
    };
  },
  components: {},
  mounted() {
    document.title = "收货地址";
    this.getAddress();
  },
  methods: {
    getAddress() {
      let that = this;
      this.$api.get("/api/user/addressList", {}, (res) => {
        console.log(res);
        // let showAdd = res.data.length>0 ? false:true;
        that.addressList = res.data;
        // that.showAdd = showAdd;
      });
    },
    addressEdit(id) {
      rbLink({
        name: "AddressEdit",
        query: {
          id: id,
        },
      });
      // this.$router.push({
      //   path: "addressedit",
      //   query: {
      //     id: id,
      //   },
      // });
    },
    toAddressAdd() {
       rbLink({
        name: "AddressAdd",
      });
    },
  },
};
</script>
<style scoped>
.box {
  height: 843px;
  background: #f8f8f8;
}
.add {
  display: flex;
  justify-content: flex-end;
}
.add img {
  width: 0.4rem;
  height: 0.4rem;
  margin-top: 0.24rem;
  margin-right: 0.2rem;
}
.add h1 {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #fa6400;
  line-height: 23px;
  margin-right: 0.2rem;
  margin-top: 0.2rem;
}
.address_list {
  margin-top: 11px;
  margin-left: 10px;
  margin-right: 10px;
  background: #ffffff;
  border-radius: 4px;
}
.address_info {
  padding: 15px 15px 0px 15px;
}
.header2 {
  display: flex;
}
.header2 h1 {
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 21px;
}
.header2 text {
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 21px;
  margin-left: 7px;
}
.body {
  margin-top: 5px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
}
.line {
  width: 95%;
  height: 1px;
  background: #ebedf0;
  margin: 0 auto;
  margin-top: 15px;
}
.first {
  margin-left: 12px;
  margin-top: 3px;
  height: 14px;
  border-radius: 3px;
  border: 1px solid #fa6400;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #fa6400;
  line-height: 14px;
}
</style>



// WEBPACK FOOTER //
// AddressList.vue?28e7bf80